import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const HOSPITALITY_DOMAIN_INTRO = {
  title: "Hospitality & Travel",
  content: "Agentic AI workflow automation for Hospitality & Travel — across Hotels, Hotels and Resorts, Travel Agencies, Travel, and Events and Banquets. Use cases span housekeeping task allocation, maintenance request triage, travel itinerary assistance, cancellation and refund workflows, staff rostering, banquet inquiry to quote, and OTA review response drafts. Practical deployments for hotels and travel operators in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Hospitality travel agentic AI — hotels, resorts, travel agencies, events banquets. Housekeeping allocation, maintenance triage, travel itinerary, banquet inquiry to quote, staff rostering, OTA review response. PMS CRS CRM integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const HOSPITALITY_SYSTEMS = "PMS, CRS, CRM, Channel Manager, Email, Power BI";

const RAW = [
  {
    id: "cancellation-and-refund-workflow",
    subIndustry: "Travel",
    department: "Customer Service",
    businessProcess: "Cancellation and refund workflow",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Cancellation and refund workflow",
    title: "Cancellation And Refund Workflow Automation for Hospitality & Travel",
    seoKeywords: "hospitality & travel, cancellation and refund workflow, AI automation, RPA, agentic AI",
    challenge: "Refunds are manually checked against fare rules, supplier policies and payment records.",
    solution: "Implement Agentic AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Travel teams can improve cancellation and refund workflow with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + RPA",
    buyerPersona: "Customer Service Head, CFO",
    systems: HOSPITALITY_SYSTEMS,
    agentsRequired: "RPA Posting Agent, Cancellation Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and cancellation and refund workflow process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for cancellation and refund workflow",
    keyBenefits: "Faster Response, Lower Service Workload, Better Customer Experience And Improved Sla Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "banquet-inquiry-to-quote",
    subIndustry: "Events and Banquets",
    department: "Sales",
    businessProcess: "Banquet inquiry to quote",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Banquet inquiry to quote",
    title: "Banquet Inquiry To Quote Automation for Hospitality & Travel",
    seoKeywords: "hospitality & travel, banquet inquiry to quote, AI automation, RPA, agentic AI",
    challenge: "Event inquiries, menus, availability and quote approvals are managed manually.",
    solution: "Implement Agentic AI + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Events and Banquets teams can improve banquet inquiry to quote with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "Banquet Sales Head",
    systems: HOSPITALITY_SYSTEMS,
    agentsRequired: "Banquet AI Agent, Validation Agent, Human Review Agent",
    inputData: "Emails, forms, system records, task notes, master data and banquet inquiry to quote process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for banquet inquiry to quote",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const HOSPITALITY_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Travel", "Events and Banquets"];
export const HOSPITALITY_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => HOSPITALITY_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'hospitality-domain', domainIntro: HOSPITALITY_DOMAIN_INTRO, useCases: HOSPITALITY_USE_CASES });
export const HOSPITALITY_USE_CASES_SEO = seo.useCasesSeo;
export const HOSPITALITY_DOMAIN_FAQS = seo.domainFaqs;
export const HOSPITALITY_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const HOSPITALITY_FAQ_JSONLD = seo.faqJsonLd;
export const HOSPITALITY_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const HOSPITALITY_WEBPAGE_JSONLD = seo.webPageJsonLd;

